import { useState } from "react";
import { Link } from "react-router-dom";
import LogoBlue from "../assets/HD-Horizontal-Blue.png";
import { supabase } from "../lib/supabase";
import Alert from "../components/Alert";

function Login() {
	const [formState, setFormState] = useState({
		email: "",
		password: "",
	});
	const [error, setError] = useState<string | null>(null);
	const [loading, setLoading] = useState(false);

	async function signInWithEmail(event: React.FormEvent<HTMLFormElement>) {
		event.preventDefault();
		setLoading(true);
		const { error } = await supabase.auth.signInWithPassword({
			email: formState.email,
			password: formState.password,
		});

		if (error) {
			if (error.code === 'user_banned') {
				setError('Account is deactivated. Contact support@happydoc.ai.');
				setLoading(false);
				return;
			}
			setError(error?.message || 'An unknown error occurred. Please try again.');
			setLoading(false);
			return;
		}
		setLoading(false);
		window.location.href = '/';
	}

	return (
		<div className="flex item-center min-h-screen flex-1 flex-col justify-center px-6 py-12 lg:px-8">
			<div className="sm:mx-auto sm:w-full sm:max-w-sm">
				<img className="mx-auto h-24 w-auto" src={LogoBlue} alt="HappyDoc" />
				<h2 className="mt-10 text-center text-xl font-semibold leading-9 tracking-tight text-gray-900">
					Sign in to your account
				</h2>
			</div>

			<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
				<form className="space-y-6" onSubmit={signInWithEmail}>
					<div>
						<label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
							Email address
						</label>
						<div className="mt-2">
							<input
								id="email"
								name="email"
								type="email"
								autoComplete="email"
								autoFocus={true}
								required
								onChange={(e) => setFormState({ ...formState, email: e.target.value })}
								className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-max-700 outline-none  sm:text-sm sm:leading-6 pl-2"
							/>
						</div>
					</div>

					<div>
						<div className="flex items-center justify-between">
							<label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
								Password
							</label>
						</div>
						<div className="mt-2">
							<input
								id="password"
								name="password"
								type="password"
								autoComplete="current-password"
								required
								onChange={(e) => setFormState({ ...formState, password: e.target.value })}
								className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-max-700 outline-none  sm:text-sm sm:leading-6 pl-2"
							/>
						</div>
						<div className="mt-2 text-right text-sm">
							<Link to="/reset-password" className="font-semibold text-max-700 hover:text-max-700">
								Forgot password?
							</Link>
						</div>
					</div>
					<div>
						<button
							className="primary-button"
							type="submit"
							disabled={formState?.email === '' || formState?.password === ''}>
							{loading ? 'Signing in...' : 'Sign in'}
						</button>
					</div>
				</form>
				{error && <div className="mt-4"><Alert alertType="error" title="Error" description={error} /></div>}
			</div>
		</div>
	);
}

export default Login;
